import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { HOTRO, TRANG_THAI_HO_TRO_OPTIONS } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { HOTRO_API } from '../../utils/apiUrl.js';

// Async Thunks

// Lấy danh sách HoTro theo paging
export const hoTroPagingAction = createAsyncThunk(
    HOTRO.GET_PAGING,
    async (model = {}, { rejectWithValue }) => {
        try {
            const pageIndex = model?.PageIndex ?? model?.pageIndex ?? 1;
            const pageSize = model?.PageSize ?? model?.pageSize ?? 20;
            const keyword = model?.Keyword ?? model?.keyword ?? '';

            const paramsObj = { PageIndex: pageIndex, PageSize: pageSize };

            if (keyword !== null && keyword !== undefined && keyword !== '') paramsObj.Keyword = keyword;
            if (model?.LinhVucId !== undefined && model?.LinhVucId !== null && model.LinhVucId !== '') paramsObj.LinhVucId = model.LinhVucId;
            if (model?.Status !== undefined && model?.Status !== null && model.Status !== '') paramsObj.Status = model.Status;
            if (model?.LoaiLoi !== undefined && model?.LoaiLoi !== null && model.LoaiLoi !== '') paramsObj.LoaiLoi = model.LoaiLoi;
            if (model?.MucDoPhucTap !== undefined && model?.MucDoPhucTap !== null && model.MucDoPhucTap !== '') paramsObj.MucDoPhucTap = model.MucDoPhucTap;
            if (model?.NguoiDungId !== undefined && model?.NguoiDungId !== null && model.NguoiDungId !== '') paramsObj.NguoiDungId = model.NguoiDungId;
            if (model?.NgayHoTroFrom) paramsObj.NgayHoTroFrom = model.NgayHoTroFrom;
            if (model?.NgayHoTroTo) paramsObj.NgayHoTroTo = model.NgayHoTroTo;
            if (model?.KhoaId !== undefined && model?.KhoaId !== null && model.KhoaId !== '') paramsObj.KhoaId = model.KhoaId;

            const params = new URLSearchParams(paramsObj);
            const url = `${HOTRO_API.GET_ALL_PAGING}?${params.toString()}`;

            const res = await Get(url);
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const hoTroGetItemAction = createAsyncThunk(
    HOTRO.GET_BY_ID,
    async (id, { rejectWithValue }) => {
        try {
            const res = await Get(HOTRO_API.GET_BY_ID(id));
            return res;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);


// Thêm HoTro mới
export const addHoTroAction = createAsyncThunk(
    HOTRO.ADD_HOTRO,
    async (model) => {
        return Post(HOTRO_API.CREATE, null, model, false)
            .then(res => res.status)
            .catch(err => err);
    }
);

// Sửa thông tin HoTro
export const editHoTroAction = createAsyncThunk(
    HOTRO.EDIT_HOTRO,
    async (model) => {
        return Put(HOTRO_API.UPDATE(model.id), null, model.data)
            .then(res => res.status)
            .catch(err => err);
    }
);

// Xóa HoTro
export const deleteHoTroAction = createAsyncThunk(
    HOTRO.DELETE_HOTRO,
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const res = await DeleteSingle(HOTRO_API.DELETE(id));

            if (res && typeof res.status === 'number') {
                if (res.status >= 200 && res.status < 300) {
                    return fulfillWithValue(res.status);
                }
                let body = null;
                try {
                    body = await res.json();
                } catch (e) {
                }
                return rejectWithValue(body || { message: 'Xóa dữ liệu thất bại' });
            }
            return rejectWithValue({ message: 'Không nhận được phản hồi từ server' });
        } catch (err) {
            return rejectWithValue(err?.message ? { message: err.message } : err);
        }
    }
);

// ---------------------------
// Initial State
// ---------------------------
const initialState = {
    listHoTro: [],
    totalHoTro: 0,
    hoTroItem: null,

    loadingPaging: false,
    loadingGetItem: false,
    loadingDelete: false,

    errorPaging: null,
    errorGetItem: null,
    errorDelete: null,
};


// ---------------------------
// Slice
// ---------------------------
export const hoTroSlice = createSlice({
    name: HOTRO.NAME_SLICE,
    initialState,
    reducers: {
        // Xóa item theo ID
        filterListHoTro: (state, action) => {
            state.listHoTro = state.listHoTro.filter(x => x.id !== action.payload);
            state.totalHoTro = Math.max(0, (state.totalHoTro || 0) - 1);
        },
        // Lọc theo trạng thái HoTro
        filterByTrangThai: (state, action) => {
            const trangThai = action.payload; // number hoặc key
            state.listHoTro = state.listHoTro.filter(x => x.trangThai === trangThai);
        }
    },
    extraReducers: (builder) => {
        builder
            // ===== Paging =====
            .addCase(hoTroPagingAction.pending, (state) => {
                state.loadingPaging = true;
                state.errorPaging = null;
            })
            .addCase(hoTroPagingAction.fulfilled, (state, action) => {
                state.loadingPaging = false;

                state.listHoTro = action.payload?.data || [];
                state.totalHoTro = action.payload?.totalRecords || 0;
            })
            .addCase(hoTroPagingAction.rejected, (state, action) => {
                state.loadingPaging = false;
                state.listHoTro = [];
                state.totalHoTro = 0;

                state.errorPaging =
                    action.payload ||
                    action.error?.message ||
                    'Không tải được danh sách hỗ trợ';
            })

            // ===== Get item =====
            .addCase(hoTroGetItemAction.pending, (state) => {
                state.loadingGetItem = true;
                state.errorGetItem = null;
            })
            .addCase(hoTroGetItemAction.fulfilled, (state, action) => {
                state.loadingGetItem = false;
                state.hoTroItem = action.payload;
            })
            .addCase(hoTroGetItemAction.rejected, (state, action) => {
                state.loadingGetItem = false;
                state.hoTroItem = null;

                state.errorGetItem =
                    action.payload ||
                    action.error?.message ||
                    'Không lấy được dữ liệu hỗ trợ';
            })

            // ===== Delete =====
            .addCase(deleteHoTroAction.pending, (state) => {
                state.loadingDelete = true;
                state.errorDelete = null;
            })
            .addCase(deleteHoTroAction.fulfilled, (state) => {
                state.loadingDelete = false;
            })
            .addCase(deleteHoTroAction.rejected, (state, action) => {
                state.loadingDelete = false;

                state.errorDelete =
                    action.payload ||
                    action.error?.message ||
                    'Xóa dữ liệu thất bại';
            });
    }

});

// Export
export const { filterListHoTro, filterByTrangThai } = hoTroSlice.actions;
export default hoTroSlice.reducer;

// Map label trạng thái HoTro
export const mapTrangThaiHoTroLabel = (trangThaiHoTro) => {
    const byValue = TRANG_THAI_HO_TRO_OPTIONS.find(x => x.value === trangThaiHoTro);
    if (byValue) return byValue.label;

    const byKey = TRANG_THAI_HO_TRO_OPTIONS.find(x => x.key === trangThaiHoTro);
    if (byKey) return byKey.label;

    return trangThaiHoTro;
};
